import { startOfDay } from 'date-fns';
import { getTestIds } from '../../utils/TestIds';
export const withTimeOfDay = (day, source)=>{
    var _ref, _ref1;
    const combined = new Date(day);
    combined.setHours((_ref = source === null || source === void 0 ? void 0 : source.getHours()) !== null && _ref !== void 0 ? _ref : 0, (_ref1 = source === null || source === void 0 ? void 0 : source.getMinutes()) !== null && _ref1 !== void 0 ? _ref1 : 0, 0, 0);
    return combined;
};
export const atStartOfDay = (day)=>{
    const normalized = new Date(day);
    normalized.setHours(0, 0, 0, 0);
    return normalized;
};
export const dayMetaFromHighlight = (highlightDay)=>highlightDay ? (day)=>highlightDay(day) ? {
            event: true
        } : null : undefined;
// WHY: date-fns throws RangeError on invalid Date instances, so callers must screen them first.
export const isValidDate = (date)=>date != null && !isNaN(date.getTime());
// WHY: an invalid Date yields an Invalid startOfDay whose comparisons are all false, so it needs no guard here.
export const violatedDateBound = (params)=>{
    const { value, minDate, maxDate, granularity = 'day' } = params;
    if (value == null) return null;
    const truncate = (date)=>granularity === 'minute' ? date : startOfDay(date);
    const comparedValue = truncate(value);
    if (maxDate != null && comparedValue > truncate(maxDate)) return 'max';
    if (minDate != null && comparedValue < truncate(minDate)) return 'min';
    return null;
};
export const GetDateCalendarTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            /** @deprecated - don't add new key here!!!! */ DateCalendarTestIds: {
                Root: (testId)=>testId ? "".concat(testId, "-calendar") : '',
                PrevMonth: (testId)=>testId ? "".concat(testId, "-prev-month") : '',
                MonthLabel: (testId)=>testId ? "".concat(testId, "-month-label") : '',
                NextMonth: (testId)=>testId ? "".concat(testId, "-next-month") : '',
                Day: (testId, year, month, date)=>"".concat(testId, "-day-").concat(year, "-").concat(month, "-").concat(date),
                DayTooltip: (testId, year, month, date)=>"".concat(testId, "-day-").concat(year, "-").concat(month, "-").concat(date, "-tooltip"),
                Action: (testId, index)=>"".concat(testId, "-action-").concat(index)
            }
        }
    });
export const GetDatePickerTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            /** @deprecated - don't add new key here!!!! */ DatePickerTestIds: {
                Root: (testId)=>testId !== null && testId !== void 0 ? testId : '',
                Input: (testId)=>testId ? "".concat(testId, "-input") : '',
                InputWrap: (testId)=>testId ? "".concat(testId, "-input-wrap") : '',
                InputBadge: (testId)=>testId ? "".concat(testId, "-input-badge") : '',
                Label: (testId)=>testId ? "".concat(testId, "-label") : '',
                HelperText: (testId)=>testId ? "".concat(testId, "-helper-text") : '',
                Btn: (testId)=>testId ? "".concat(testId, "-btn") : '',
                Loading: (testId)=>testId ? "".concat(testId, "-loading") : '',
                Popover: (testId)=>testId ? "".concat(testId, "-popover") : '',
                BottomSheet: (testId)=>testId ? "".concat(testId, "-bottom-sheet") : '',
                BottomSheetTitle: (testId)=>testId ? "".concat(testId, "-bottom-sheet-title") : '',
                Row: (testId)=>testId ? "".concat(testId, "-row") : '',
                RowLabel: (testId)=>testId ? "".concat(testId, "-row-label") : '',
                RowValue: (testId)=>testId ? "".concat(testId, "-row-value") : '',
                RowEditBtn: (testId)=>testId ? "".concat(testId, "-row-edit-btn") : '',
                Time: (testId)=>testId ? "".concat(testId, "-time") : '',
                Done: (testId)=>testId ? "".concat(testId, "-done") : ''
            }
        }
    });
// WHY: the popper portals to <body>, so only popper.js sees the anchor's width; it writes the
// reference width onto the popper so the two-column card ends where the field ends.
export const matchFieldWidthModifier = {
    name: 'matchFieldWidth',
    enabled: true,
    phase: 'beforeWrite',
    requires: [
        'computeStyles'
    ],
    fn: (param)=>{
        let { state } = param;
        state.styles.popper.width = "".concat(state.rects.reference.width, "px");
    }
};
